<template>
  <CHeader fixed with-subheader light style="height: 60px">
    <CToggler in-header class="ml-3 d-lg-none" v-c-emit-root-event:toggle-sidebar-mobile />
    <CToggler in-header class="ml-3 d-md-down-none" v-c-emit-root-event:toggle-sidebar  @click="resize" />
    <CHeaderBrand class="mx-auto d-lg-none" src="img/brand/logo.svg" width="60" height="50" alt="Getchee Logo" />
    <CHeaderNav class="d-md-down-none mr-auto"> </CHeaderNav>
    <CHeaderNav class="mr-4">
      <!--Purchase-->
      <!--
      <CButton
        v-if="$route.path !== '/myAccount' && !isBetaSite"
        @click="BillingPurchase"
        style="background: #f6c857; color: #3c4b64"
        >購買</CButton
      >-->
      <TheHeaderDropdownAccnt />
    </CHeaderNav>
    <CSubheader class="px-3" style="display: none">
      <CBreadcrumbRouter class="border-0" />
    </CSubheader>
  </CHeader>
</template>

<script>
import axios from "axios";
import appSettings from "@/util/settings";
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },
  data() {
    return {
      isBetaSite: false,
    };
  },
  methods: {
    BillingPurchase() {
      let currentRouterName = this.$router.currentRoute.name;
      this.$router.push({
        name: "MyAccount",
        params: { OutSidePurchaseModal: true, TriggerRouterName: currentRouterName },
      });
    },
    async getTicketList() {
      axios
        .post(appSettings.VoucherList, {
          userToken: this.$store.state.token,
        })
        .then(await this.storeVoucherList)
        .catch(function (error) {
          console.log(error);
        });
    },
    storeVoucherList(response) {
      const data = response.data;
      const voucherList = data.VoucherList;

      if (!data.IsLogin) {
        this.$store.commit("clearUser");
        this.$router.replace({ name: "Login" });
      } else {
        const totalVoucherCount = voucherList.reduce((a, b) => a + b.Count, 0);
        // console.log(`totalVoucherCount`, totalVoucherCount);

        this.$store.commit("set", ["voucherList", voucherList]);
        if (totalVoucherCount > 0) {
          this.$store.commit("set", ["isFreeAcount", false]);
        } else {
          this.$store.commit("set", ["isFreeAcount", true]);
        }
      }
    },
    resize() {
      this.$store.commit("setMapFuncDelegate", {funcName: "resize"});
    }
  },
  mounted() {
    this.getTicketList();
    this.isBetaSite = window.location.href.includes("qabeta.getchee.com");
  },
};
</script>

<style lang="css" scoped>
::v-deep button:focus {
  outline: none;
}
</style>
